module.exports = __webpack_public_path__ + "img/xaas-telegram.84e71cb.png";